// 1구역 2구역 나뉘는 것
import styled from 'styled-components';
import thumbnail from 'src/assets/images/user-mobile/parking/parking-user-thumbnail.png';
import thumbnailWheat from 'src/assets/images/user-mobile/parking/parking-user-thumbnail-wheat.webp';
import blackIcon from 'src/assets/images/user-mobile/parking/open-detail.svg';
import whiteIcon from 'src/assets/images/user-mobile/parking/open-detail-white.svg';
import noticeImg from 'src/assets/images/user-mobile/parking/notice.png';
import { apiParking } from 'src/apis/utils/parking';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { parkingFestivalList } from 'src/assets/database/parkingData';
import ParkingList from './ParkingList';
// allbutton, allbuttonText, background필요

export default function ParkingArea({ festivalId }: { festivalId: number }) {
  const navigate = useNavigate();
  const [notice, setNotice] = useState('');
  const festivalStyle = parkingFestivalList.find(
    f => f.festivlaId === festivalId,
  )?.data;

  useEffect(() => {
    if (!festivalId) return;
    const fetchNotice = async () => {
      try {
        const { data } = await apiParking.getParkingInfo(festivalId);
        setNotice(data.announcement);
      } catch (err) {
        console.error('공지사항 불러오기 실패', err);
      }
    };
    fetchNotice();
  }, [festivalId]);

  return (
    <AreaContainer>
      <ImageArea>
        <SummaryContainer>
          <span>주차장 혼잡도</span>를 확인하고,
          <p>
            <span>여유로운 공간</span>에 주차하세요.
          </p>
        </SummaryContainer>
        {notice && ( // 공지사항 있을 때만 렌더링
          <NoticeArea>
            <img src={noticeImg} alt="공지사항" />
            <NoticeContent
              dangerouslySetInnerHTML={{
                __html: notice.replace(/\n/g, '<br />'),
              }}
            />{' '}
          </NoticeArea>
        )}

        <ThumbnailImg
          src={festivalId === 7 ? thumbnail : thumbnailWheat}
          alt="섬네일 이미지"
        />
        <OpenDetailImg
          onClick={() => navigate('/parking/detail')}
          bgColor={festivalStyle?.allbutton}
          textColor={festivalStyle?.allbuttonText}
          festivalId={festivalId}
        >
          <Image src={festivalId === 7 ? blackIcon : whiteIcon} alt="열기" />
          <div>주차장 전체 보기</div>
        </OpenDetailImg>
      </ImageArea>
      <ListTitle>주차장 혼잡도</ListTitle>
      <ParkingList festivalId={festivalId} />
    </AreaContainer>
  );
}

const AreaContainer = styled.div`
  margin-top: 52px;
  width: 100%;
`;
const ImageArea = styled.div<{ background?: string }>`
  position: relative;

  width: 100%;
  height: 100%;
  padding-bottom: 56px;

  background: ${({ background }) =>
    background || 'linear-gradient(180deg, #fff 0%, #f4f3f4 100%)'};

  color: var(--Font-02_black, #111);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.45px;

  span {
    font-weight: 600;
  }
`;

const SummaryContainer = styled.div`
  padding: 12px 0 0 20px;
`;

const ThumbnailImg = styled.img`
  width: 100%;
  height: 100%;
  padding: 36px 32px 0 32px;
`;

const Image = styled.img`
  width: 16px;
  height: 16px;
`;

const OpenDetailImg = styled.button<{
  bgColor?: string;
  textColor?: string;
  festivalId?: number;
}>`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  padding: ${({ festivalId }) => (festivalId === 9 ? '11px 20px' : '9px 18px')};
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 24px;
  box-shadow: ${({ festivalId }) =>
    festivalId === 9
      ? '0px 2px 2px 0px rgba(17, 17, 17, 0.08);'
      : '0px 2px 2px 0px rgba(0, 0, 0, 0.08)'};
  background: ${({ bgColor }) => bgColor || '#fff'};
  color: ${({ textColor }) => textColor || '#111'};
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 146.667% */
  letter-spacing: -0.375px;
`;

const ListTitle = styled.div`
  width: 100%;
  height: 50px;
  flex-shrink: 0;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 16px 20px 10px 20px;

  color: var(--Font-02_black, #111);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px; /* 130% */
  letter-spacing: -0.5px;
`;

const NoticeArea = styled.div`
  margin: 12px 12px 0 12px;
  height: 100%;
  padding: 12px 16px;
  display: flex;
  gap: 8px;

  flex-direction: row;
  color: #df0000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: -0.4px;
  border-radius: 16px;
  background: #fef6f6;

  img {
    width: 20px;
    height: 20px;
    margin-top: 2px;
  }
`;

const NoticeContent = styled.p``;
